import axios from "@/api/http";

export function importData(token, data) {
  return axios({
    url: '/api/orangevPrivate/importData',
    responseType: 'blob',
    method: 'post',
    headers: {
      'authorization': token
    },
    data: data
  })
}
